import Vue from 'vue'
import VueRouter from 'vue-router'
// 登陆界面
import Index from '../components/index.vue'
import Login from '../components/Login.vue'
import mob from '../components/mob.vue'
import zichan from '../components/zichan.vue'
import myOrder from '../components/myOrder.vue'
import task from '../components/task.vue'
import zhutu from '../components/guest/zhutu.vue'
import xiangqing from '../components/guest/xiangqing.vue'
import baokuan from '../components/guest/baokuan.vue'

import koutu from '../components/guest/koutu.vue'
import jingxiu from '../components/guest/jingxiu.vue'

// 登陆界面
import Admin from '../components/Admin.vue'
// 首页
import home from '../components/home.vue'
import mobHome from '../components/mobHome.vue' // 用来设计主要布局的
// 汇总页
import welcome from '../components/admin/welcome.vue'
import yysWelcome from '../components/yys/welcome.vue'
// h5 手机页面 路由
import mobWelcome from '../components/mob/welcome0.vue'

// 大模型管理 *****************20260722
import damoxing from '../components/admin/damoxing/damoxing.vue'
import damoxingRec from '../components/admin/damoxing/damoxing_rec.vue'

import gonggao from '../components/admin/system/gonggao.vue'
import zixun from '../components/admin/system/zixun.vue'
import anli from '../components/admin/yunying/anli.vue'

import chongzhiMingxi from '../components/admin/caiwu/chongzhi_mingxi.vue'
import xiaofeiMingxi from '../components/admin/caiwu/xiaofei_mingxi.vue'
import renwuMingxi from '../components/admin/caiwu/renwu_mingxi.vue'

// 城市管理 1
import chengshiRead from '../components/admin/chengshi/read.vue'
// 企业管理 2
import qiyeRead from '../components/admin/qiye/read.vue'
// 设备管理 3
import macRead from '../components/admin/yunying/macAll.vue'
// 客户管理 4
import guestRead from '../components/admin/guest/guest_read.vue'
import guestBaobiao from '../components/admin/guest/guest_baobiao.vue'
import guestHuifang from '../components/admin/guest/guest_huifang.vue'
// 订单管理 5
import orderRead from '../components/admin/order/read.vue'
// 活动管理 6
import huodongRead from '../components/admin/huodong/read.vue'
// 服务管理 7
// import productRead from '../components/admin/product/read.vue'
// import productLog from '../components/admin/product/log.vue'
// 财务管理 8
import caiwuOrderMingxi from '../components/admin/money/order_mingxi.vue'
import caiwuOrderMoneyMingxi from '../components/admin/money/money_mingxi.vue'
// 报表部分 9
import macHuizong from '../components/admin/baobiao/macHuizong.vue'
import macMingxi from '../components/admin/baobiao/macMingxi.vue'
import fuwuMingxi from '../components/admin/baobiao/fuwuMingxi.vue'
import saleDayBaobiao from '../components/admin/baobiao/saleDayBaobiao.vue'
import saleMonthBaobiao from '../components/admin/baobiao/saleMonthBaobiao.vue'
// 系统设置 10
import log from '../components/admin/system/log.vue'
import user from '../components/admin/system/user.vue'
import quanxian from '../components/admin/system/quanxian.vue'
import juese from '../components/admin/system/juese.vue'
import leixing from '../components/admin/system/leixing.vue'
// 2023年7月22日 sx002项目新加页面
// 系统设置
import jiChu from '../components/admin/system/jichu.vue'
// import qyuser from '../components/admin/system/qyuser.vue'
// 财务
import fenRun from '../components/admin/caiwu/fenrun.vue'
// import tixian from '../components/admin/caiwu/tixian.vue'
// 图文A
import fuwu from '../components/admin/tuwen/fuwu.vue'
import huodong from '../components/admin/tuwen/huodong.vue'
import caifeng from '../components/admin/tuwen/caifeng.vue'
import zijia from '../components/admin/tuwen/zijia.vue'
import lunbo from '../components/admin/tuwen/lunbo.vue'
// 总览
import zonglan from '../components/admin/zonglan/zonglan.vue'
// 门店管理
import yunying from '../components/admin/yunying/mendian.vue'
import chongzhi from '../components/admin/yunying/chongzhi.vue'
// 充值档位设置（积分充值 / 会员档位，后台可维护）
import chongzhiConfig from '../components/admin/yunying/chongzhi_config.vue'
import guestAdmin from '../components/admin/yunying/guestAdmin.vue'
// import kucun from '../components/admin/yunying/kucun.vue'

// -------------------------门店管理界面菜单导航-------------------------------

import mendianKucun from '../components/yys/mendian/kucun.vue'
import mendianRuku from '../components/yys/mendian/ruku.vue'
import mendianKchuizong from '../components/yys/mendian/kchuizong.vue'
import shangjia from '../components/yys/yysSshangcheng/shangjia.vue'
import shangchengChanpin from '../components/yys/shangcheng/chanpin.vue'
// import shangchengShangjia from '../components/yys/shangcheng/shangjia.vue'
import caiwuJiesuan from '../components/yys/caiwu/jiesuan.vue'

import guest from '../components/yys/jichu/guest.vue'
import adminMoban from '../components/admin/moban/moban.vue'
import xiaoqu from '../components/yys/jichu/xiaoqu.vue'
import zhandian from '../components/yys/jichu/zhandian.vue'
import jichuCanshu from '../components/yys/jichu/canshu.vue'

import mac from '../components/yys/jichu/mac.vue'
import fenzhang from '../components/yys/caiwu/fenzhang.vue'

import dingdan from '../components/yys/yunwei/dingdan.vue'
import yunyingdan from '../components/yys/yunwei/yunyingdan.vue'
import yysMingxi from '../components/yys/yunwei/mingxi.vue'
import dianka from '../components/yys/yunwei/dianka.vue'
import orderDianka from '../components/yys/yunwei/order_dianka.vue'
import weixiu from '../components/yys/yunwei/weixiu.vue'
import baobiao from '../components/yys/yunwei/baobiao.vue'

import tuikuan from '../components/yys/caiwu/tuikuan.vue'
// import jiesuan from '../components/yys/caiwu/jiesuan.vue'
import caiwubb from '../components/yys/caiwu/caiwubb.vue'
import xuanchuan from '../xuanchuan/xuanchuan.vue'

// --------------------[sp_create_router] 生成 ----------------------
// --------------合作门店--------------------
import jichuYuangong from '../components/yys/jichu/yuangong.vue'
import jichuChanpin from '../components/yys/jichu/chanpin.vue'
import adminChanpin from '../components/admin/system/chanpin.vue'
import adminChuzhiChanpin from '../components/admin/system/chuzhi.vue'
import zuheShangpin from '../components/admin/system/zuheShangpin.vue'

import shigongGuest from '../components/yys/shigong/guest.vue'
import shigongKaidan from '../components/yys/shigong/kaidan.vue'
import shigongCheliang from '../components/yys/shigong/cheliang.vue'
import shigongJiancha from '../components/yys/shigong/jiancha.vue'
import shigongYunYingdan from '../components/yys/shigong/yunyingdan.vue'
import shigongBaojiadan from '../components/yys/shigong/baojiadan.vue'
import shigongPaidan from '../components/yys/shigong/paidan.vue'
import shigongZhijian from '../components/yys/shigong/zhijian.vue'
import shigongJiesuan from '../components/yys/shigong/jiesuan.vue'
import shigongYichuli from '../components/yys/shigong/yichuli.vue'

import scorder from '../components/yys/shigong/scorder.vue'

import yunyingYuYue from '../components/yys/yunying/yuyue.vue'
import yunyingHuiyuanka from '../components/yys/yunying/huiyuanka.vue'
import yunyingYeji from '../components/yys/yunying/yeji.vue'
import yunyingJixiao from '../components/yys/yunying/jixiao.vue'
import yunyingXiaoXi from '../components/yys/yunying/xiaoxi.vue'
import yunyingPingjia from '../components/yys/yunying/pingjia.vue'
// import mendianShangpin from '../components/yys/mendian/shangpin.vue'

import adminRuku from '../components/admin/yunying/ruku.vue'
import adminChuku from '../components/admin/yunying/chuku.vue'
import adminKucun from '../components/admin/yunying/kucun.vue'

import caiwuHuizong from '../components/tongyong/huizong.vue'
import yysCaiwuTixian from '../components/yys/caiwu/tixian.vue'
// import caiwuTongji from '../components/yys/caiwu/tongji.vue'
// 商城部分

// ---------------管理员-------------------

// 财务明细
import mingxi from '../components/admin/caiwu/mingxi.vue'

import yunyingGuest from '../components/admin/yunying/guest.vue'
import yunyingShigong from '../components/admin/yunying/shigong.vue'
import youhuiquan from '../components/admin/yunying/youhuiquan.vue'

import yunyingYingxiao from '../components/admin/yunying/yingxiao.vue'
import caiwuTixian from '../components/admin/caiwu/tixian.vue'

// 财务明细的13个项目
import adminXiaofei from '../components/admin/caiwu/xiaofei.vue'
import adminXianjin from '../components/admin/caiwu/xianjin.vue'
import adminBaoyang from '../components/admin/caiwu/baoyang.vue'
import adminJiyou from '../components/admin/caiwu/jiyou.vue'
import adminXiche from '../components/admin/caiwu/xiche.vue'

import adminInfo from '../components/admin/info/info.vue'

import adminFenhong from '../components/admin/caiwu/fenhong.vue'
import adminTuikuan from '../components/admin/caiwu/tuikuan.vue'
import adminDongjie from '../components/admin/caiwu/dongjie.vue'

import adminYingjiao from '../components/admin/caiwu/yingjiao.vue'
import adminRukuZhanghu from '../components/admin/caiwu/rukuzhanghu.vue'
import adminMendianshoukuan from '../components/admin/caiwu/mendianshoukuan.vue'

import caiwuTongji from '../components/admin/caiwu/tongji.vue'

import caiwuTuandui from '../components/admin/yingxiao/tuandui.vue'
import caiwuMingxi from '../components/admin/yingxiao/mingxi.vue'

import shangchengShangpin from '../components/admin/shangcheng/shangpin.vue'
import shangchengKucun from '../components/admin/shangcheng/kucun.vue'
import shangchengShangjia from '../components/admin/shangcheng/shangjia.vue'
import shangchengBeiyong from '../components/admin/shangcheng/beiyong.vue'

import yysJichuShangpin from '../components/yys/jichu/shangpin.vue'

// import yysShangchengKucun from '../components/yys/shangchengYys/kucun.vue'
// import yysShangchengShangjia from '../components/yys/shangchengYys/shangjia.vue'
// import shangchengBeiyongYys from '../components/yys/shangchengYys/beiyong.vue'

Vue.use(VueRouter)
const routes = [
  // {
  //   path: '/xuanchuan',
  //   name: 'xuanchuan',
  //   component: xuanchuan,
  //   meta: { title: '提示页面' }
  // },
  {
    path: '/mob',
    name: 'mob',
    component: mob,
    meta: { title: '系统登陆' }
  },
  {
    path: '/Index',
    name: 'Index',
    component: Index,
    meta: { title: 'mello' }
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: { title: '企业用户登录入口' }
  },
  {
    path: '/Admin',
    name: 'admin',
    component: Admin,
    meta: { title: '管理员登录页' }
  },
  {
    path: '/zichan',
    name: 'zichan',
    component: zichan,
    meta: { title: '用户资产' }
  },
  {
    path: '/myorder',
    name: 'myOrder',
    component: myOrder,
    meta: { title: '我的订单' }
  },
  {
    path: '/task',
    name: 'task',
    component: task,
    meta: { title: '我的任务' }
  },
  // ************** 子菜单路由 
  {
    path: '/zhutu',
    name: 'zhutu',
    component: zhutu,
    meta: { title: '商品主图' }
  },
  {
    path: '/xiangqing',
    name: 'xiangqing',
    component: xiangqing,
    meta: { title: 'A+详情' }
  },
  {
    path: '/baokuan',
    name: 'baokuan',
    component: baokuan,
    meta: { title: '爆款图复刻' }
  },
    {
    path: '/koutu',
    name: 'koutu',
    component: koutu,
    meta: { title: '扣图' }
  },
    {
    path: '/jingxiu',
    name: 'jingxiu',
    component: jingxiu,
    meta: { title: '精修' }
  },
  // *********************用于手机版本路由，根路由***************************
  //   {
  //   path: '/mobIndex',
  //   name: 'mobIndex',
  //   component: mobIndex,
  //   meta: { title: '抢单大厅' }
  // },
  //   {
  //   path: '/mobMine',
  //   name: 'mobMine',
  //   component: mobMine,
  //   meta: { title: '我的订单' }
  // },
  //   {
  //   path: '/mobMy',
  //   name: 'mobMy',
  //   component: mobMy,
  //   meta: { title: '我的资料' }
  // },
  // *********************用于手机版本路由，根路由***************************
  {
    path: '/home',
    name: 'home',
    component: home,
    //       --以下是跳转 ---
    redirect: 'welcome',
    //    --以下是子路由--
    children: [
      { path: '/welcome', component: welcome, name: '首页', meta: { title: '首页', role: '2' } },
      {
        path: '/zonglan/zonglan',
        component: welcome,
        name: '总览',
        meta: { title: '总览', role: '2' }
      },
      {
        path: '/system/canshu',
        component: jichuCanshu,
        name: '系统参数',
        meta: { title: '系统参数', role: '2' }
      },
      {
        path: '/system/gonggao',
        component: gonggao,
        name: '系统公告',
        meta: { title: '系统公告', role: '2' }
      },
      {
        path: '/system/zixun',
        component: zixun,
        name: '最新资讯',
        meta: { title: '最新资讯', role: '2' }
      },
      {
        path: '/yunying/guest',
        component: guestRead,
        name: '客户管理',
        meta: { title: '客户管理', role: '2' }
      },
      {
        path: '/yunying/chongzhi',
        component: chongzhiConfig,
        name: '充值设置',
        meta: { title: '充值设置', role: '2' }
      },
      {
        path: '/yunying/anli',
        component: anli,
        name: '案例管理',
        meta: { title: '案例管理', role: '2' }
      },
      {
        path: '/damoxing/damoxing',
        component: damoxing,
        name: '大模型管理',
        meta: { title: '大模型管理', role: '2' }
      },
      {
        path: '/damoxing/damoxing_rec',
        component: damoxingRec,
        name: '使用记录',
        meta: { title: '使用记录', role: '2' }
      },
      {
        path: '/caiwu/chongzhi_mingxi',
        component: chongzhiMingxi,
        name: '充值明细',
        meta: { title: '充值明细', role: '2' }
      },
      {
        path: '/caiwu/xiaofei_mingxi',
        component: xiaofeiMingxi,
        name: '消费明细',
        meta: { title: '消费明细', role: '2' }
      },
      {
        path: '/caiwu/renwu_mingxi',
        component: renwuMingxi,
        name: '任务明细',
        meta: { title: '任务明细', role: '2' }
      },
      {
        path: '/system/juese',
        component: juese,
        name: '角色管理',
        meta: { title: '角色管理', role: '2' }
      },
      {
        path: '/system/user',
        component: user,
        name: '用户设置',
        meta: { title: '用户设置', role: '2' }
      },
      {
        path: '/system/quanxian',
        component: quanxian,
        name: '权限设置',
        meta: { title: '权限设置', role: '2' }
      },
      {
        path: '/system/jichu',
        component: jiChu,
        name: '基础信息',
        meta: { title: '基础信息', role: '2' }
      },
      // { path: '/qiye/qiyeRead', component: qiyeRead, name: '企业管理', meta: { title: '企业管理', role: '2' } },

      {
        path: '/yunying/yunying',
        component: yunying,
        name: '员工管理',
        meta: { title: '员工管理', role: '2' }
      },
      {
        path: '/yunying/guest',
        component: yunyingGuest,
        name: '客户管理',
        meta: { title: '客户管理', role: '2' }
      },
      // { path: '/shangcheng/shangpin', component: shangchengShangpin, name: '商品管理00', meta: { title: '商品管理', role: '2' } },
      {
        path: '/yunying/chanpin',
        component: adminChanpin,
        name: '商品管理-管理员',
        meta: { title: '商品管理', role: '2' }
      },
      {
        path: '/yunying/chuzhi',
        component: adminChuzhiChanpin,
        name: '储值商品',
        meta: { title: '储值商品', role: '2' }
      },
      {
        path: '/yunying/zuheShangpin',
        component: zuheShangpin,
        name: '组合商品',
        meta: { title: '组合商品', role: '2' }
      },
      {
        path: '/yunying/kucun',
        component: adminKucun,
        name: '门店库存',
        meta: { title: '门店库存', role: '2' }
      },
      {
        path: '/yunying/ruku',
        component: adminRuku,
        name: '入库管理',
        meta: { title: '入库管理', role: '2' }
      },
      {
        path: '/yunying/chuku',
        component: adminChuku,
        name: '出库管理',
        meta: { title: '出库管理', role: '2' }
      },
      {
        path: '/yunying/shigong',
        component: yunyingShigong,
        name: '施工管理',
        meta: { title: '施工管理', role: '2' }
      },
      {
        path: '/yunying/youhuiquan',
        component: youhuiquan,
        name: '优惠券',
        meta: { title: '优惠券', role: '2' }
      },
      {
        path: '/yunying/info',
        component: adminInfo,
        name: '信息管理',
        meta: { title: '信息管理', role: '2' }
      },

      {
        path: '/caiwu/tixian',
        component: caiwuTixian,
        name: '财务审核',
        meta: { title: '财务审核', role: '2' }
      },
      {
        path: '/caiwu/adminxiaofei',
        component: adminXiaofei,
        name: '客户消费明细',
        meta: { title: '客户消费明细', role: '2' }
      },
      {
        path: '/caiwu/xianjin',
        component: adminXianjin,
        name: '客户现金明细',
        meta: { title: '客户现金明细', role: '2' }
      },
      {
        path: '/caiwu/baoyang',
        component: adminBaoyang,
        name: '客户保养账户',
        meta: { title: '客户保养账户', role: '2' }
      },
      {
        path: '/caiwu/jiyou',
        component: adminJiyou,
        name: '客户机油卡明细',
        meta: { title: '客户机油卡明细', role: '2' }
      },
      {
        path: '/caiwu/xiche',
        component: adminXiche,
        name: '客户洗车卡明细',
        meta: { title: '客户洗车卡明细', role: '2' }
      },
      {
        path: '/yingxiao/fenhong',
        component: adminFenhong,
        name: '客户分红账户明细',
        meta: { title: '客户分红账户明细', role: '2' }
      },
      {
        path: '/caiwu/admintuikuan',
        component: adminTuikuan,
        name: '客户退款明细',
        meta: { title: '客户退款明细', role: '2' }
      },
      {
        path: '/caiwu/dongjie',
        component: adminDongjie,
        name: '财务冻结明细',
        meta: { title: '财务冻结明细', role: '2' }
      },
      {
        path: '/caiwu/yingjiao',
        component: adminYingjiao,
        name: '客户应缴明细',
        meta: { title: '客户应缴明细', role: '2' }
      },
      {
        path: '/caiwu/rukuZhanghu',
        component: adminRukuZhanghu,
        name: '门店入库账户明细',
        meta: { title: '门店入库账户明细', role: '2' }
      },
      {
        path: '/caiwu/mendianshoukuan',
        component: adminMendianshoukuan,
        name: '门店收款明细',
        meta: { title: '门店收款明细', role: '2' }
      },

      {
        path: '/shangcheng/chanpin',
        component: shangchengChanpin,
        name: '商城商品',
        meta: { title: '商城商品', role: '2' }
      },
      {
        path: '/shangcheng/shangjia',
        component: shangchengShangjia,
        name: '上架管理',
        meta: { title: '上架管理', role: '2' }
      },
      {
        path: '/yingxiao/mingxi',
        component: caiwuMingxi,
        name: '分红明细',
        meta: { title: '分红明细', role: '2' }
      },
      {
        path: '/yingxiao/tuandui',
        component: caiwuTuandui,
        name: '用户团队',
        meta: { title: '用户团队', role: '2' }
      },

      {
        path: '/tuwen/fuwu',
        component: fuwu,
        name: '服务中心',
        meta: { title: '服务中心', role: '2' }
      },
      {
        path: '/tuwen/huodong',
        component: huodong,
        name: '糖豆活动',
        meta: { title: '糖豆活动', role: '2' }
      },
      {
        path: '/tuwen/caifeng',
        component: caifeng,
        name: '豆友采风',
        meta: { title: '豆友采风', role: '2' }
      },
      {
        path: '/tuwen/zijia',
        component: zijia,
        name: '糖友自驾',
        meta: { title: '糖友自驾', role: '2' }
      },
      {
        path: '/tuwen/lunbo',
        component: lunbo,
        name: '轮播图',
        meta: { title: '轮播图', role: '2' }
      }
    ]
    // 路由 是由路径匹配后，进行跳转到相应组件，然后组件再显示
    // 路由 所在位置由所在页面加入 view-router 标签，
    //  然后在该页面路由的子路由下进行匹配
  },
  {
    path: '/yysHome',
    name: 'yysHome',
    component: home,
    //       --以下是跳转 ---
    redirect: 'yysWelcome',
    //    --以下是子路由--
    children: [
      {
        path: '/yysWelcome',
        component: yysWelcome,
        name: '首页-门店',
        meta: { title: '首页-门店', role: '1' }
      },
      {
        path: '/zonglan/zonglan',
        component: welcome,
        name: '总览',
        meta: { title: '总览', role: '2' }
      },
      {
        path: '/jichu/yuangong',
        component: jichuYuangong,
        name: '员工管理-门店',
        meta: { title: '员工管理', role: '1' }
      },
      {
        path: '/jichu/chanpin',
        component: jichuChanpin,
        name: '商品管理-门店',
        meta: { title: '商品管理', role: '1' }
      },
      {
        path: '/jichu/canshu',
        component: jichuCanshu,
        name: '系统参数-门店',
        meta: { title: '系统参数', role: '1' }
      },

      {
        path: '/shigong/kaidan',
        component: shigongKaidan,
        name: '服务开单',
        meta: { title: '服务开单', role: '1' }
      },
      {
        path: '/shigong/jiesuan',
        component: shigongJiesuan,
        name: '结算管理',
        meta: { title: '结算管理', role: '1' }
      },
      {
        path: '/shigong/yichuli',
        component: shigongYichuli,
        name: '已处理订单',
        meta: { title: '已处理订单', role: '1' }
      },
      {
        path: '/shigong/scorder',
        component: scorder,
        name: '商城订单',
        meta: { title: '商城订单', role: '1' }
      },
      {
        path: '/shigong/guest',
        component: shigongGuest,
        name: '客户管理-门店',
        meta: { title: '客户管理', role: '1' }
      },
      {
        path: '/shigong/cheliang',
        component: shigongCheliang,
        name: '车辆管理-门店',
        meta: { title: '车辆管理', role: '1' }
      },
      {
        path: '/shigong/jiancha',
        component: shigongJiancha,
        name: '检查管理',
        meta: { title: '检查管理', role: '1' }
      },
      {
        path: '/shigong/yunyingdan',
        component: shigongYunYingdan,
        name: '运营单管理',
        meta: { title: '运营单管理', role: '1' }
      },

      {
        path: '/yunying/yuyue',
        component: yunyingYuYue,
        name: '预约管理',
        meta: { title: '预约管理', role: '1' }
      },
      {
        path: '/mendian/ruku',
        component: mendianRuku,
        name: '入库管理',
        meta: { title: '入库管理', role: '1' }
      },
      {
        path: '/mendian/kucun',
        component: mendianKucun,
        name: '库存查询-门店',
        meta: { title: '库存查询', role: '1' }
      },

      {
        path: '/yysSshangcheng/Shangjia',
        component: shangjia,
        name: '商品上架',
        meta: { title: '商品上架', role: '1' }
      },

      {
        path: '/caiwu/jiesuan',
        component: caiwuJiesuan,
        name: '结算查询',
        meta: { title: '结算查询', role: '1' }
      },
      {
        path: '/caiwu/huizong',
        component: caiwuHuizong,
        name: '业绩汇总',
        meta: { title: '业绩汇总', role: '1' }
      }
    ]
    // 路由 是由路径匹配后，进行跳转到相应组件，然后组件再显示
    // 路由 所在位置由所在页面加入 view-router 标签，
    //  然后在该页面路由的子路由下进行匹配
  },

  {
    path: '/mobWelcome',
    component: mobWelcome,
    name: '首页',
    meta: { title: 'login', role: '3' }
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})
// 挂载导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // document.head.appendChild('./assets/log/pziot.ico')
    document.title = 'AI-' + to.meta.title
  }
  if (to.path === '/index') return next()
  // if (to.path === '/login') return next()
  // if (to.path === '/Login') return next()
  if (to.path === '/Admin') return next()
  if (to.path === '/admin') return next()
  if (to.path === '/mob') return next()

  // 获取token

  const tokenStr = window.sessionStorage.getItem('token')
  const tokenUserType = window.sessionStorage.getItem('tokenUserType')
  console.log(888, tokenUserType, tokenStr)
  if (to.path === '/zichan') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
  if (to.path === '/myorder') {
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
  if (to.path === '/task') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
  if (to.path === '/zhutu') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
  if (to.path === '/xiangqing') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
  if (to.path === '/baokuan') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
    if (to.path === '/koutu') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }
    if (to.path === '/jingxiu') {
    // console.log(123, tokenUserType)
    if (tokenUserType !== '0') return next()
    else return next('/mob')
  }

  if (tokenStr) {
    // 假如是有权限
    console.log(881, tokenUserType, to.meta.role, to.meta)
    if (tokenUserType === to.meta.role) return next()
    else {
      // if (tokenUserType === '1') return next('/Login')
      console.log(tokenUserType)
      if (tokenUserType === '2') return next('/admin')
      if (tokenUserType === '3') return next('/mob')
    }
  } else {
    // 所有页面功能都是通过该地址进行跳转到入口，分权限页面只需要通过该接口接入即可
    if (tokenUserType === 2) return next('/admin')
    else if (tokenUserType === 3) return next('/index')
    else return next('/index')
  }
})
// to 要访问的路径
// from 从哪个路径而来
// next 一个放行函数
export default router
